import { render, staticRenderFns } from "./UserPayrollRates.vue?vue&type=template&id=02b96a67&scoped=true&"
import script from "./UserPayrollRates.vue?vue&type=script&lang=ts&"
export * from "./UserPayrollRates.vue?vue&type=script&lang=ts&"
import style0 from "./UserPayrollRates.vue?vue&type=style&index=0&id=02b96a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b96a67",
  null
  
)

export default component.exports